module.exports = __webpack_public_path__ + "static/media/appDownload@2x.8cb4bfd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post-onboarding/appDownload@2x.png
// module id = 2071
// module chunks = 71